<main id="site-main">
    <div class="inner-content">
        <section id="hero">
            <div class="content">
                <h1>ردیاب شیلات؛ نظارت هوشمند، صید پایدار</h1>
                <h2>اتحادیه سراسری تعاونی های صیادی ایران</h2>

                <button class="btn btn-primary" [routerLink]="['/login/profile']">ورود | ثبت‌نام</button>
            </div>
        </section>
    </div>
</main>

<app-footer></app-footer>